export default __webpack_public_path__ + "static/media/VealParm.9ef5ef02.jpg";